import { enterpriseBrandUserManagementInteractionClickSendInvitation } from 'core/telemetry/avo/Avo';

export const telemetryUserManagementClickSendInvitationInteraction = () => {
  enterpriseBrandUserManagementInteractionClickSendInvitation();
};
